module.exports = __webpack_public_path__ + "img/jazz-fm.e8bf1e06.png";